import {IBusinessConfigurations, IService, IShopItem} from "@torim-app/types";
import {adminUrlBuilder} from "@app/api/utils";

export class ShopApi {
  static readonly path = 'shop';

  static async editSettings(
    body: Partial<Pick<IBusinessConfigurations,
      'isShowShopInWebsite' | 'isShowShopAfterAppointmentSchedule' | 'enableDirectProductOrders' | 'productPickupPolicy'>>
  ) {
    const url = adminUrlBuilder({}, `${ShopApi.path}/settings`);
    const response = await fetch(url, {
      method: 'put',
      headers: {
        'content-type': 'application/json'
      },
      body: JSON.stringify(body)
    });
    if (!response.ok)
      throw `Failed to edit product`;
  }

  static async addProduct(
    body: IShopItem
  ) {
    const url = adminUrlBuilder({}, `${ShopApi.path}/product`);
    const response = await fetch(url, {
      method: 'post',
      headers: {
        'content-type': 'application/json'
      },
      body: JSON.stringify(body)
    });
    if (!response.ok)
      throw `Failed to add new product`;
  }

  static async editProduct(
    body: IShopItem
  ) {
    const url = adminUrlBuilder({}, `${ShopApi.path}/product`);
    const response = await fetch(url, {
      method: 'put',
      headers: {
        'content-type': 'application/json'
      },
      body: JSON.stringify(body)
    });
    if (!response.ok)
      throw `Failed to edit product`;
  }

  static async deactivateProduct(
    productId: string
  ) {
    const url = adminUrlBuilder({}, `${ShopApi.path}/product`);
    const response = await fetch(url, {
      method: 'delete',
      headers: {
        'content-type': 'application/json'
      },
      body: JSON.stringify({productId})
    });
    if (!response.ok)
      throw `Failed to deactivate product`;
  }
}
